import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ToggleButton } from '@omnea-app/frontend/components/shared/ui/toggle-button/ToggleButton'
import { CountBadge } from '@omnea-app/omui/CountBadge'

type ResolveButtonsProps = {
  loading: boolean
  unresolvedMentionsCount: number
  handleResolveChange: (value: boolean) => void
  showResolved: boolean
}

export const ResolveButtons = ({ loading, unresolvedMentionsCount, handleResolveChange, showResolved }: ResolveButtonsProps) => {
  const { t } = useTranslation('dashboard')
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <ToggleButton
        label={
          <>
            {t('mentions.unresolved')}
            {!loading && unresolvedMentionsCount !== 0 && <CountBadge count={unresolvedMentionsCount} color="neutral" />}
          </>
        }
        onClick={() => handleResolveChange(false)}
        isSelected={!showResolved}
      />
      <ToggleButton label={t('mentions.resolved')} onClick={() => handleResolveChange(true)} isSelected={showResolved} />
    </Stack>
  )
}
